import {
	Box,
	Chip,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material'

export function DeliveryActivityView({ deliveryStats }) {
	const deliveries = deliveryStats?.recentDeliveries || []

	return (
		<Box>
			{deliveries.length === 0 ? (
				<Box display="flex" justifyContent="center" alignItems="center" minHeight="30vh">
					<Typography color="text.secondary">No recent delivery activity.</Typography>
				</Box>
			) : (
				<TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
					<Table>
						<TableHead>
							<TableRow sx={{ '& th': { fontWeight: 600, color: 'text.secondary', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' } }}>
								<TableCell>Customer</TableCell>
								<TableCell>Sensor ID</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Response</TableCell>
								<TableCell>Time</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{deliveries.map((delivery, index) => (
								<TableRow key={index} hover>
									<TableCell>
										<Typography variant="body2">{delivery.customer?.name || 'N/A'}</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
											{delivery.sensor_id}
										</Typography>
									</TableCell>
									<TableCell>
										<Chip
											label={delivery.status}
											size="small"
											color={delivery.status === 'success' ? 'success' : 'error'}
										/>
									</TableCell>
									<TableCell>
										<Typography variant="body2" color="text.secondary">
											{delivery.response_code || '—'}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" color="text.secondary">
											{new Date(delivery.attempted_at).toLocaleString()}
										</Typography>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
		</Box>
	)
}
